import * as Datas from "@data";
import {axiosPostUtil} from "./axiosUtil";

const api = {
  v1: {
    board: {
      getList: async ({
        page = 1,
        limit = 20,
        ...args
      }: {
        limit?: number;
        page?: number;
        searchTxt?: string;
      }) => {
        return (await axiosPostUtil)<
          Datas.ApiResponse<
            Datas.ResultPagingResponse<Datas.IBoardListResponse[]>
          >
        >("/api/v1/board/getList", {
          ...args,
          page,
          limit,
        }).then(value => value.data);
      },

      getDetail: async (params: {no: number}) => {
        return await axiosPostUtil<Datas.ApiResponse<Datas.IBoardResponse>>(
          "/api/v1/board/getDetail",
          params,
        ).then(value => value.data);
      },
    },

    notice: {
      getList: async ({
        page = 1,
        limit = 20,
        ...args
      }: {
        searchTxt?: string;
        limit?: number;
        page?: number;
      }) => {
        return (await axiosPostUtil)<
          Datas.ApiResponse<
            Datas.ResultPagingResponse<Datas.INoticeListResponse[]>
          >
        >("/api/v1/notice/getList", {
          ...args,
          page,
          limit,
        }).then(value => value.data);
      },

      getDetail: async (params: {no: number}) => {
        return await axiosPostUtil<Datas.ApiResponse<Datas.INoticeResponse>>(
          "/api/v1/notice/getDetail",
          params,
        ).then(value => value.data);
      },
    },

    info: {
      getList: async () => {
        return await axiosPostUtil<
          Datas.ApiResponse<{result: Datas.IInfoResponse[]}>
        >("/api/v1/info/getList").then(value => value.data);
      },
    },

    adv: {
      getList: async () => {
        return await axiosPostUtil<
          Datas.ApiResponse<{result: Datas.IAdvResponse[]}>
        >("/api/v1/adv/getList").then(value => value.data);
      },
    },

    member: {
      getList: async (params: {
        sequnce?: number;
        page: number;
        limit?: number;
        isFront?: boolean;
        searchTxt?: string;
      }) => {
        return await axiosPostUtil<
          Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IMemberResponse[]>>
        >("/api/v1/member/getList", {...params, isFront: true}).then(
          value => value.data,
        );
      },
    },

    user: {
      login: async (params: {sns_type: string; sns_token: string}) => {
        return await axiosPostUtil<
          Datas.ApiResponse<{
            token: {
              accessToken: string;
              refreshToken: string;
            };
          }>
        >("/api/v1/user/login", params).then(value => value?.data);
      },

      getUser: async () => {
        return await axiosPostUtil<
          Datas.ApiResponse<{
            result: Datas.IMember;
            token: {
              accessToken: string;
              refreshToken: string;
            };
          }>
        >("/api/v1/user/getUser").then(value => value?.data);
      },
    },

    popup: {
      getList: async () => {
        return await axiosPostUtil<
          Datas.ApiResponse<{result: Datas.IPopupResponse[]}>
        >("/api/v1/popup/getList").then(value => value.data);
      },
    },
  },
};

export default api;
